import React from 'react';
import svgUrl from './DiscIconSmall.svg';

const DiscIconSmall = function DiscIconSmall() {
  return <img src={svgUrl} alt="" className="disc-icon-small" loading="lazy" decoding="async" />;
};

export default DiscIconSmall;
